<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      ref="editForm"
      :rules="rules"
    >
      <el-row>
        <el-form-item label="客户名称" prop="outCustomerName">
          <el-input
            size="small"
            v-model="editForm.outCustomerName"
            auto-complete="off"
            placeholder="客户名称"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="业务员名称" prop="outSalesman">
          <el-autocomplete
            size="small"
            style="width: 220px"
            v-model="editForm.outSalesman"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="
              handleConfirmSelectSaleman($event, editForm, 'outSalesman')
            "
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="业务员助手" prop="outInterSalesman">
          <el-autocomplete
            size="small"
            style="width: 220px"
            v-model="editForm.outInterSalesman"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="
              handleConfirmSelectSaleman($event, editForm, 'outInterSalesman')
            "
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="出点（%）" prop="outPercentage">
          <el-input-number
            :min="0"
            :max="100"
            size="small"
            :controls="false"
            v-model="editForm.outPercentage"
            placeholder="出点（%）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="出库状态" prop="outStatus">
          <el-select
            size="small"
            v-model="editForm.outStatus"
            placeholder="请选择"
          >
            <el-option
              v-for="type in statusType"
              :label="type.key"
              :value="type.value"
              :key="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价员" prop="outBidder">
          <el-autocomplete
            size="small"
            v-model="editForm.outBidder"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, editForm, 'outBidder')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >下一步</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <Payment
      :visible.sync="visiblePayment"
      :editForm="editForm"
      @confirm="handlePayment"
    ></Payment>
    <Salesman
      :visible.sync="salesmanVisible"
      @confirm="handleConfirmSelectSaleman"
    ></Salesman>
  </el-dialog>
</template>

<script>
import Payment from "./payment.vue";
import { deliverTicket } from "@/api/ticket/ticket";
import { listSalesman } from "@/api/system/user";
import Salesman from "@/views/components/salesman";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    Payment,
    Salesman,
  },
  data() {
    return {
      salesmanVisible: false,
      statusType: [
        { key: "空", value: "" },
        { key: "扣息打款", value: "扣息打款" },
        { key: "打全款", value: "打全款" },
        { key: "扣息有小款", value: "扣息有小款" },
        { key: "回全款有小款", value: "回全款有小款" },
      ],
      visiblePayment: false,
      rules: {
        outCustomerName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
        outPercentage: [
          { required: true, message: "请输入出点（%）", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, originData, type) {
      if (data) {
        if (type === "outBidder") {
          originData.outBidder = data.realName;
          originData.outBidderId = data.id;
        } else if (type === "outSalesman") {
          originData.outSalesman = data.realName;
          originData.outSalesmanId = data.id;
        } else if (type === "outInterSalesman") {
          originData.outInterSalesman = data.realName;
          originData.outInterSalesmanId = data.id;
        }
      }
    },
    handleSerachSalesman() {
      this.salesmanVisible = true;
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          deliverTicket(this.editForm)
            .then(() => {
              this.visiblePayment = true;
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
    handlePayment() {
      this.handleClose();
      this.$emit("confirm");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-estimate/add-edit/index.vue